import * as React from "react";

class TermsComponent extends React.Component {
  render(): JSX.Element {
    return (
      <div className="single-page">
        <div className="page-title">
          <div className="big-title">Terms and Conditions</div>
        </div>
        <div className="terms-conditions">
          <ol className="provisions">
            <li>
              <h3>Introduction</h3>
              <p>
                Welcome to Fikafy - the app for Users.
                <br />
                Fikafy allows Users to discover, chat and meet
                Users nearby.
              </p>
              <p>
                The Fikafy AB, Starrängsringen 8, 115 50 Stockholm, Sweden (hereinafter
                referred to as ‘Operator’) operates website (fikafy.com and
                other country specific domain fikafy.se) and mobile app (Fikafy
                app for iOS) (hereinafter referred as ‘Fikafy services’), under
                the name “Fikafy”.
              </p>
              <p>
                Terms and conditions (hereinafter referred to as ‘Terms’) apply
                to the use of all Fikafy services. By using Fikafy services the
                user accepts the Terms. If the user does not accept Fikafy
                Terms, the use of any Fikafy service is prohibited.
              </p>
            </li>
            <li>
              <h3>Offered Services</h3>
              <p>
                Fikafy is a service for Users, where registered users
                (hereinafter referred to as “Users” or User) can
                discover and chat with Users nearby. This is permitted
                as long as Users do not violate Fikafy Terms.
              </p>
              <p>
                The Fikafy app can be downloaded free of charge from the Apple
                App Store (currently available to limited users).
              </p>
              <p>
                The Operator is not responsible by the information provided by
                Users. The Operator reserves the right to terminate
                User’s account temporarily or permanently, with or
                without notice, with or without any specific reasons. If a
                User has been blocked or his/her account is terminated,
                he/she may contact the Operator via email to support@fikafy.com
                and request for clarification, if any.
              </p>
            </li>
            <li>
              <h3>Contractual Conditions</h3>
              <p>
                The Operator only provides a platform for Users to
                discover and chat with nearby Users. Operator is not
                responsible for any deal, contract, meeting or any sort business
                between Users.
              </p>
            </li>
            <li>
              <h3>Eligibility, registration and deletion of account</h3>
              <p>
                Registration is required to use Fikafy services. The use of
                Fikafy service is permitted for individuals over the age of 18
                year, who are viable to entering a legally binding contract.
              </p>
              <p>
                Commercial use of Fikafy services is strictly forbidden, unless
                its approved by the Operator.
              </p>
              <p>
                Operator relies on Facebook for registration and login.
                Users should keep Facebook login credentials
                confidential, if those are compromised, Fikafy services are
                compromised, in that case Operator needs to be informed
                immediately or change the access credentials on Facebook.
              </p>
              <p>
                By Registering, the user agrees to receiving recurring
                newsletters from Operator, and therefore receives information
                from Operator on regular intervals.
              </p>
              <p>
                Users can delete their account at any time, further
                information can be found in Fikafy Privacy Policy.
              </p>
            </li>
            <li>
              <h3>Termination of account</h3>
              <p>
                Operator reserves the right to terminate the User
                account with or without any reason specified. Fikafy services
                are aimed to provide a neat, simple and fast service to
                Users and User’s account will be terminated with in 24 hours if
                found not aligned with Fikafy services or found involved in abusive acts.
              </p>
            </li>
            <li>
              <h3>Content on Fikafy</h3>
              <p>
                Content created by Users is only approved if we found it aligned with our values.
              </p>
              <p>
                There is zero tolerance for objectionable content. 
                If content is reported as abusive or objectionable, 
                Fikafy reserves the right to remove it within 24 hours.
              </p>
            </li>
            <li>
              <h3>Liability</h3>
              <p>
                The Operator cannot be held liable for correctness of the
                information provided by Users. Operator is not liable
                for any damage caused by errors, interruptions, malfunctions in
                technical systems, deletion or loss of data, viruses, Facebook
                login or any other damage which can occur during use of Fikafy
                services.
              </p>
              <p>
                The foregoing limitations of liability include claim against the
                representatives or employees of the Operator. The Operator is
                not liable for the content, accuracy, legality and functionality
                of any third party services, e.g. Facebook login, Facebook
                pages, Firebase, Google Analytics etc..
              </p>
              <p>
                Operator is not liable for technical transmission delays or
                technical failures and does not assume the responsibility that
                the Fikafy services are continuously usable or accessable.
                Fikafy services are only accessible with the active internet
                connection. The Operator excludes any warranty of functionality
                of the Fikafy services. The Operator is not liable for the
                unauthorised knowledge attainment of any data by third parties
                such as hackers.
              </p>
            </li>
            <li>
              <h3>Data protection</h3>
              <p>
                Operator takes data protection very seriously. Privacy rules
                specified in Fikafy Privacy Policy apply.
              </p>
            </li>
            <li>
              <h3>Fikafy trademarks rights</h3>
              <p>
                Fikafy and other trademarks owned by operator may not be used
                without express consent.
              </p>
            </li>
            <li>
              <h3>Violations of the Terms</h3>
              <p>
                In case of violation of one or more of these provision the
                Operator is entitled to temporarily or permanently delete
                User’s account. In case a User account has been
                blocked/deleted, he can write to support@fikafy.com and ask for
                clarification, if any.
              </p>
            </li>
            <li>
              <h3>Amendment of Terms</h3>
              <p>
                The updated Terms will be published here as soon as Operator
                changes the Terms. An explicit reference to the change of the
                Terms will not be made. Users shall review the Terms
                periodically to check for changes. If the User does not
                agree with the changes, she/he can delete or request the
                deletion of her/his account.
              </p>
            </li>
          </ol>
        </div>
      </div>
    );
  }
}

export default TermsComponent;



// WEBPACK FOOTER //
// ./src/components/terms.component.tsx